"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageNodeWithAspectRatio = exports.imageNode = exports.getLinkNodes = void 0;
var getLinkNodes = function (min, max) { return ({
    name: "linkNodes",
    label: "Liens",
    type: "object",
    // @ts-expect-error
    max: max,
    min: min,
    list: true,
    templates: [
        {
            name: "internalLink",
            label: "Lien interne",
            ui: {
                itemProps: function (values) {
                    return {
                        label: "".concat(values.label || "Lien interne"),
                    };
                },
            },
            fields: [
                {
                    name: "label",
                    label: "Label",
                    type: "string",
                },
                {
                    name: "internalLink",
                    label: "Page",
                    type: "reference",
                    collections: ["page"],
                },
                {
                    name: "anchor",
                    label: "Ancre",
                    type: "string",
                },
            ],
        },
        {
            name: "externalLink",
            label: "Lien externe",
            fields: [
                {
                    name: "label",
                    label: "Label",
                    type: "string",
                },
                {
                    name: "url",
                    label: "Lien",
                    type: "string",
                },
            ],
        },
        {
            name: "fileLink",
            label: "Lien vers un fichier",
            fields: [
                {
                    name: "label",
                    label: "Label",
                    type: "string",
                },
                {
                    name: "fileLink",
                    label: "Fichier",
                    type: "image",
                },
            ],
        },
    ],
}); };
exports.getLinkNodes = getLinkNodes;
exports.imageNode = {
    name: "imageNode",
    label: "Image",
    type: "object",
    fields: [
        {
            name: "image",
            label: "Image",
            type: "image",
        },
        {
            name: "alt",
            label: "Texte alternatif",
            type: "string",
        },
        {
            name: "credits",
            label: "Crédits",
            type: "string",
        },
    ],
};
exports.imageNodeWithAspectRatio = __assign(__assign({}, exports.imageNode), { type: "object", 
    // @ts-expect-error
    fields: __spreadArray(__spreadArray([], exports.imageNode.fields, true), [
        {
            name: "aspectRatio",
            label: "Ratio de l'image",
            type: "string",
            component: "select",
            options: [
                {
                    label: "Naturel",
                    value: "natural",
                },
                {
                    label: "Carré",
                    value: "square",
                },
                {
                    label: "Portrait",
                    value: "portrait",
                },
                {
                    label: "Paysage",
                    value: "landscape",
                },
            ],
        },
    ], false) });
